<script>
import lazyLoadComponent from '@router/lazyload-component'
import { merchantComputed, authComputed } from '@state/helpers'
import { messageStore } from '@utils/message'
const initData = () => {
  return {
    title: '線上儲值',
    image: '',
    description: '',
    terms: '',
    isEnabled: 0,
    bannerImages: [],
    bannerImage: ''
  }
}

const formatToForm = (data) => {
  const { images = [{ path: '', default: 0 }], bannerImages = [{ path: '', default: 0 }], ...resetData } = data
  return {
    ...resetData,
    image: images[0]?.path || '',
    bannerImage: bannerImages[0]?.path || '',
  }
}

export default {
  components: {
    BaseUpload: () => lazyLoadComponent(import('@components/BaseUpload')),
  },
  props: {
    defaultValue: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      submitData: Object.assign({}, initData(), formatToForm(this.defaultValue)),
      tryingStore: false,
    }
  },
  computed: {
    ...merchantComputed,
    ...authComputed,
    fromatPrapaidTerms() {
      return `${this.currentMerchant.name || '店家'} ${this.submitData.title || '線上儲值'}使用注意事項

${this.currentMerchant.name || '店家'}（後稱「本店」）提供「${this.submitData.title || '線上儲值'}消費方式」（後稱「本服務」）予本店會員使用，以下為本服務使用規則說明：
一. 認知與接受條款
    當會員臨櫃儲值點數或透過線上系統儲值點數，表示會員已閱讀、瞭解並同意接受本合約所載條款。若持卡人不同意下述之任何條款，請勿使用本服務。本店得隨時修改或變更本合約之條款並於${this.$t('APP_NAME')}${this.$t('APP_SUBNAME')}平台公告，如會員於前開修改或變更後繼續持儲值點數消費時，視為會員已閱讀、瞭解並同意接受該等修改或變更。
二. 使用方式
    1. 持儲值點數得於本店或透過${this.$t('APP_NAME')}${this.$t('APP_SUBNAME')}平台於本店消費，1點可折抵1元新台幣，無使用期限及次數之限制。
    2. 儲值點數僅限本店會員臨櫃購買及透過${this.$t('APP_NAME')}${this.$t('APP_SUBNAME')}平台辦理線上儲值，嗣後消費時再依消費金額開立收據或發票。
    3. 持儲值點數消費時，會員需以儲值點數全額結清該張訂單，若當次消費金額超出卡片餘額時，應先自行補足差額，不得以儲值點數部分付款。
    4. 若使用儲值點數消費後辦理取消訂單或退貨時，全部款項將退至會員本服務之帳戶中。
    5. 會員得臨櫃申辦儲值點數全部（而非部分）餘額之退費，會員可至本店臨櫃或${this.$t('APP_NAME')}${this.$t('APP_SUBNAME')}平台線上查詢點數餘額，退款可退回扣除消費金額後之實際支付金額，優惠贈送點數恕無法折現退還。
    6. 本店適用本服務支付之項目：[將適用範圍條列]
三. ${this.$t('APP_NAME')}${this.$t('APP_SUBNAME')}平台僅代本店以電子記錄方式提供本服務進出之帳務代管，實際可供消費使用之內容及細節係由本店提供，如有消費爭議請透過以下管道聯絡本店，電話：${this.currentMerchant.phoneNumber || '－'}、信箱：${this.currentMerchant.email || '－'}。
四. 本店為履行本合約須向會員或其他第三人蒐集個人資料時，如上述之人因故未簽署個人資料同意書、拒絕提供個人資料或提供之個人資料不完全者，本公司將不提供相關服務。
五. 本店有權在任何時候拒絕任何人進入消費。
六. 本合約之任何條款或部分如因任何理由被認定為無效或無法執行者，其無效或無法執行以該條款或部分為限，不影響其他條款或該條款其他部分之有效性。
七. 本合約之準據法為中華民國法律。因本合約涉訟時，雙方同意以司法院公告本店所屬轄區之地方法院為第一審管轄法院。`
    },
    canSetPrice() {
      return this.$can('api', 'setPrice')
    },
    formRules() {
      return {
        title: [
          {
            required: true,
            message: '請輸入儲值金方案名稱'
          }
        ],
        terms: [
          {
            required: true,
            message: '請輸入儲值金使用條款'
          }
        ]

      }
    },
    foramttedSubmitData() {
      const { image, bannerImage, ...resetData } = this.submitData
      return {
        ...resetData,
        images: image === '' ? [] : [
          {
            path: image ?? '',
            default: 0
          }
        ],
        bannerImages: bannerImage === '' ? [] : [
          {
            path: bannerImage ?? '',
            default: 0
          }
        ],
      }
    },
  },
  watch: {
    defaultValue(nvl) {
      this.submitData = Object.assign({}, initData(), formatToForm(nvl))
    }
  },
  created() {
    // 空的不要帶預設值（原本空的有帶，現在先拿掉
    // if(!this.defaultValue.terms){
    //   this.setDefaultContact()
    // }
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    onClickLeave() {
      this.$emit('update')
      this.submitData = Object.assign({}, initData(), formatToForm(this.defaultValue))
    },
    async tryToStore() {
      try {
        await this.validate()
        this.tryingStore = true
        await this.$store.dispatch('merchant/postCosmeticBasicSet', {
          type: 'deposit',
          payload: this.foramttedSubmitData
        })
        messageStore('edit')
        this.$emit('update')
      } catch {

      } finally {
        this.tryingStore = false
      }

    },
    setDefaultContact() {
      this.submitData.terms = this.fromatPrapaidTerms
    }

  },
}
</script>

<template>
  <div :class="$style.pageContent" style="margin-bottom:80px">
    <div class="isStylePageContent">
      <el-form ref="form" :model="submitData" :rules="formRules" :validate-on-rule-change="false" label-position="top"
        :class="$style.form" autocomplete="off">

        <el-row :gutter="10">
          <el-col :span="24">
            <h4 data-tour-text="" class="form-block-title justify-content-stat fs-lg"><span
                class="isStyleRequired">選單名稱</span> <span class="ml-3 text-danger text-secondary fs-sm">此名稱會顯示在前台</span>
            </h4>
            <el-form-item prop="title" required>
              <el-input v-model="submitData.title" />
            </el-form-item>
            <el-divider></el-divider>
          </el-col>
          <el-col :sm="24" :span="24" class="align-self-center">
            <div class="inline-between">
              <h3 style="font-size:16px;">前台是否顯示儲值點數</h3>
              <el-form-item label="" prop="isEnabled" class="mb-0">
                <el-switch v-model="submitData.isEnabled" active-text="是" inactive-text="否" :active-value="1"
                  :inactive-value="0"> </el-switch>
              </el-form-item>
            </div>
            <el-divider></el-divider>
          </el-col>
          <el-col v-if="!$isIpetBooking()" :sm="24" :span="24">
            <h4 data-tour-text="">Banner圖片</h4>
            <el-form-item prop="images" label="">
              <BaseUpload v-if="submitData" v-model="submitData.bannerImage" :display-column="true" :width-full="true"
                is-between is-deposit dir="/deposit" suggest-size="1920/248" resource="deposit" type="custom" />
            </el-form-item>
            <el-divider></el-divider>
          </el-col>

          <el-col :sm="24" :span="24">
            <h4 data-tour-text="">圖片簡介</h4>
            <el-form-item prop="images" label="">
              <BaseUpload v-model="submitData.image" is-between is-deposit dir="/deposit" suggest-size="866/379"
                resource="deposit" type="custom" />
            </el-form-item>
            <el-divider></el-divider>
          </el-col>

          <el-col :span="24">
            <h4 data-tour-text="" class="form-block-title mt-0 fs-lg">使用說明</h4>
            <el-form-item label="" prop="description">
              <el-input v-model="submitData.description" type="textarea" class="is-border is-round bg-white"
                :autosize="{ minRows: 5 }" />

            </el-form-item>
            <el-divider></el-divider>
          </el-col>
          <el-col :span="24">
            <h4 data-tour-text="" class="form-block-title mt-0">儲值金使用條款</h4>
            <el-form-item label="" prop="terms" :class="[$style['inputContract']]">
              <div>
                <span :class="$style.label" class="text-secondary">
                  條款說明
                </span>
                <el-button class="is-round mb-3" @click="setDefaultContact">引用系統提供的儲值金方案定型化契約
                </el-button>
              </div>
              <el-input v-model="submitData.terms" placeholder="請輸入條款" type="textarea" class="is-border is-round bg-white"
                :autosize="{ minRows: 7 }" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div :class="$style.footer">
      <el-button class="is-round" @click="onClickLeave">取消編輯</el-button>
      <el-button class="is-round" type="primary" :loading="tryingStore" @click="tryToStore">儲存編輯</el-button>
    </div>
  </div>
</template>
<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';

.form {
  :global {
    .el-input-group__prepend {
      padding-left: 0;
    }
  }
}

%img-size {
  width: calc(33.333333% - 10px);
  height: 175px;

  @include max-sm {
    width: calc(100% - 10px);
  }
}

:global {
  :local(.upload) {
    margin: 0 -10px;
    border-top: none !important;

    >div {
      @extend %img-size;
    }

    .image-and-action {
      @extend %img-size;

      &+div {
        @extend %img-size;
      }
    }
  }
}

.inputContract {
  .label {
    padding-right: 10px;

    &:after {
      content: ' *';
      color: red;
    }
  }
}

.form-item--split {
  display: flex;
  align-items: center;
  height: 40px;
  line-height: 40px;

  :global {
    .el-radio-group {
      flex-shrink: 0;
      margin-right: 15px;
    }

    .el-input {
      max-width: 150px;
    }
  }
}
</style>
